import { Component, Element, Host, h } from '@stencil/core';
import warn from '../../../../capabilities/warn';
import FieldDecorator from '../_interfaces/FieldDecorator';

/**
 * NOTE: The radio button does not support validity the same way other input types do.
 * While it does support "required", it does not support individual validation since radio buttons
 * always appear in groups. Note that "required" may be be applied to any ONE of the group and it
 * applies to the entire set.
 *
 * Reference: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/radio#validation
 *
 * @description form-kit: Applies Design System styles to a slotted radio button field.
 *
 * @use
 * @formkit
 * @since 6.0.0
 * @slot - `default slot`: The radio button element to be decorated.
 */
@Component({
  tag: 'hp6-radio-button-decorator',
  styleUrl: 'radio-button-decorator.scss',
  shadow: true,
})
export class RadioButtonDecorator implements FieldDecorator {
  @Element() host: HTMLElement;

  /**
   * getter for the decoratored <input /> element
   */
  get decoratedEl(): HTMLInputElement {
    const el = this.host.querySelector('input[type="radio"]') as HTMLInputElement;
    return el;
  }

  componentDidRender() {
    this.decorate();
  }

  decorate() {
    const { decoratedEl } = this;

    if (!decoratedEl) {
      return;
    }
    const hasId = decoratedEl.getAttribute('id');
    if (!hasId) {
      warn(
        'radio-button-decorator: input does not have an id attribute. This is required to associate the label with the input.',
      );
    }
  }

  render() {
    return (
      <Host data-decorator="radio-button">
        <slot />
      </Host>
    );
  }
}
